export default "__VITE_ASSET__f9d49d56__"